import getStore from '../store';
import { mutator } from 'satcheljs';
import { setAutoScrollItemId } from '../actions/searchResultStoreActions';

/**
 * Sets item Id of the element to be auto-scrolled to
 */
export let setAutoScrollItemIdMutator = mutator(setAutoScrollItemId, item => {
    let store = getStore();
    store.autoScrollItemId = item.autoScrollItemId;
});
